import React from 'react'
import { Link } from 'react-router-dom'
import './Card.css'
const Card = ({ image, name, url }) => {
  return (
  
        <div className="card">
        <Link to={url}>
            <img className="image" src={image} alt={name} />
            <div className="project_name">{name}</div>
        </Link>
    </div>
  
  )
}

export default Card